import React from 'react';
import CalculatorWindow from '../components/CalculatorWindow.js';

const CalculatorWindowText = () => {
    return (
        <>
            <div className="w-full flex justify-center py-6 px-4 sm:px-8 md:px-16">
                <div className="w-full lg:w-3/4 bg-white px-4 sm:px-6 lg:px-8 py-8 sm:py-10 rounded-2xl">
                    <h1 className="text-3xl font-bold text-primary mb-6">Förderung von Maßnahmen zur Verbesserung der Gebäudehülle</h1>
                    <p className="text-lg text-gray-800 mb-6">
                        Einzelne Modernisierungsmaßnahmen an bestehenden Gebäuden, die der Steigerung der Energieeffizienz dienen, können gefördert werden. Dazu zählen Arbeiten an der Gebäudehülle, wie etwa die Dämmung von Außenwänden oder Dachflächen sowie der Austausch oder die Neuinstallation von Fenstern und Türen.
                    </p>
                    <div className='mt-16 mb-16'>
                        <CalculatorWindow />
                        </div>
                    <h2 className="text-2xl font-semibold text-black mb-4">Förderfähige Maßnahmen:</h2>
                    <ul className="list-disc list-inside text-lg text-gray-800 mb-6">
                        <li><strong>Dämmmaßnahmen:</strong> Isolation von Außenwänden, Dachflächen, Geschossdecken und Bodenflächen sowie Sanierung oder Austausch von Vorhangfassaden.</li>
                        <li><strong>Fenster und Türen:</strong> Erneuerung, Austausch oder erstmalige Installation von Fenstern, Außentüren und -toren.</li>
                        <li><strong>Sonnenschutz:</strong> Installation oder Austausch von außenliegenden Sonnenschutzeinrichtungen mit optimierter Tageslichtsteuerung.</li>
                        <li><strong>Heizungsoptimierung:</strong> Durchführung eines hydraulischen Abgleichs oder andere Maßnahmen zur Effizienzsteigerung der Heizungsanlage.</li>
                    </ul>

                    <h2 className="text-2xl font-semibold text-black mb-4">Wichtige Hinweise:</h2>
                    <p className="text-lg text-gray-800 mb-6">
                        Für die Antragstellung ist die Zusammenarbeit mit einem zertifizierten Energieeffizienz-Experten (EEE) erforderlich. Wir unterstützen Sie gern bei diesem Prozess und stehen Ihnen beratend zur Seite.
                    </p>

                    <h2 className="text-2xl font-semibold text-black mb-4">Förderhöhe:</h2>
                    <ul className="list-disc list-inside text-lg text-gray-800 mb-6">
                        <li><strong>Grundfördersatz:</strong> 15 % der förderfähigen Kosten, einschließlich der Ausgaben für die Energieberatung.</li>
                        <li><strong>Zusatzbonus:</strong> Im Rahmen eines individuellen Sanierungsfahrplans (iSFP) erhöht sich die Förderung um 5 %, wenn die Maßnahmen Teil dieses Plans sind.</li>
                    </ul>

                    <p className="text-lg text-gray-800 mb-6">
                        Durch diese Förderungen profitieren Sie nicht nur von einer verbesserten Energieeffizienz Ihres Gebäudes, sondern reduzieren auch die Kosten Ihrer Investition erheblich.
                    </p>
                </div>
            </div>
        </>
    );
};

export default CalculatorWindowText;